import brand from '@helpers/brand';
import fonts from '@helpers/fonts';
import { Device, from } from '@helpers/media';
import svgChevronDown from '@img/icons/chevron-down.svg';
import styled from 'styled-components';
const Container = styled.div `
  position: relative;
  display: block;
  width: auto;
`;
const Select = styled.select `
  display: block;
  appearance: none;
  background: transparent url('${svgChevronDown}') no-repeat;
  background-position: center right 12px;
  background-size: 14px 6px;
  border: 1px solid ${brand.sage.sageLight};
  border-radius: 4px 4px 0 0 ;
  color: ${brand.sage.sageLight};
  ${fonts.matter.medium};
  font-size: 14px;
  line-height: 42px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  height: 52px;
  padding: 0 30px 0 12px;
  width: 100%;

  @media ${from(Device.Desktop)} {
    background-position: center right 18px;
    padding: 0 30px 0 15px;
    min-width: 200px;
  }

  &:hover,
  &:focus {
    border: 1px solid ${brand.sage.sageDark};
    color: ${brand.sage.sageDark};
  }

  option {
    font-size: 18px;
    line-height: 50px;
    padding: 15px;
    color: ${brand.black};
  }

  &:disabled {
    cursor: not-allowed;
    background-color: ${brand.grey.greyLight};
  }
`;
export default {
    Container,
    Select,
};
